// @ts-nocheck
import { PRODUCT_LIST_ERROR, PRODUCT_LIST_LOADING, PRODUCT_LIST_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const ProductListReducer = (state = initialState, action) => {
    switch (action.type) {
        case PRODUCT_LIST_LOADING:
            return Object.assign({}, state, { loading: true })
        case PRODUCT_LIST_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case PRODUCT_LIST_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}
